import type { ErrorType } from '~/data/ErrorRecord';
import type { AssetTypeDataType, AssetTypeType } from './types';

export const defaultState: AssetTypesState = {
  assetTypesData: {},
  assetTypes: [],
  isLoading: false,
  error: undefined,
};

export interface AssetTypesState {
  assetTypesData: Record<string, AssetTypeDataType>;
  assetTypes: AssetTypeType[];
  isLoading: boolean;
  error?: ErrorType;
}
